import { useTheme, mono, EqBox, Card, Label } from "./appHelpers";

export default function AttitudePage() {
  const C = useTheme();
  return (
    <div>
      <Card color="#6366f1">
        <Label color="#6366f1">Head-to-Head Comparison</Label>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, paddingBottom:8, borderBottom:`1px solid ${C.border}`, marginBottom:4 }}>
          <div style={{ ...mono, fontSize:9, color:C.muted }}>METRIC</div>
          <div style={{ ...mono, fontSize:9, color:"#f59e0b" }}>REACTION WHEEL</div>
          <div style={{ ...mono, fontSize:9, color:"#22c55e" }}>EP-ADCS EMMS</div>
        </div>
        {[["Residual jitter (RMS)","700–1,200 μrad","< 5 μrad"],["Response time","5–10 min spin-up","< 0.2 seconds"],["Bearing lifetime","3–7 years","No bearings"],["Desaturation prop","0.08 kg/year","Zero"],["Power (hold)","5–15 W continuous","4 mW average"],["Failure mode","Lubrication failure","None critical"],["Post-failure","Tumble (Kepler, Hayabusa)","No change"]].map(([l,rw,ep]) => (
          <div key={l} style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, padding:"7px 0", borderBottom:`1px solid ${C.border}20` }}>
            <div style={{ ...mono, fontSize:10, color:C.text }}>{l}</div>
            <div style={{ ...mono, fontSize:10, color:"#ef4444" }}>{rw}</div>
            <div style={{ ...mono, fontSize:10, color:"#22c55e", fontWeight:600 }}>{ep}</div>
          </div>
        ))}
      </Card>
      <Card color="#0e9cc0">
        <Label>Image Smear at 450km</Label>
        <EqBox lines={["Linear smear = altitude × angular jitter","","Reaction wheel (800 μrad):","  smear = 450,000m × 0.0008 = 360 metres per pixel","","EP-ADCS EMMS (5 μrad):","  smear = 450,000m × 0.000005 = 2.25 metres per pixel","","EP-ADCS delivers 160× better pointing stability.","For 1m GSD imaging: RW causes 360× resolution loss, EMMS causes 2.25×."]} />
      </Card>
    </div>
  );
}
